__turbopack_context__.v({
  "button": "userProfileBadgeContainer-module-scss-module__h6ijda__button",
  "container": "userProfileBadgeContainer-module-scss-module__h6ijda__container",
  "icon": "userProfileBadgeContainer-module-scss-module__h6ijda__icon",
  "iconOpen": "userProfileBadgeContainer-module-scss-module__h6ijda__iconOpen",
  "logInBtnSpinner": "userProfileBadgeContainer-module-scss-module__h6ijda__logInBtnSpinner",
  "logInBtnSpinnerWrapper": "userProfileBadgeContainer-module-scss-module__h6ijda__logInBtnSpinnerWrapper",
  "loginButton": "userProfileBadgeContainer-module-scss-module__h6ijda__loginButton",
  "menuArrow": "userProfileBadgeContainer-module-scss-module__h6ijda__menuArrow",
  "menuContent": "userProfileBadgeContainer-module-scss-module__h6ijda__menuContent",
  "menuWrapper": "userProfileBadgeContainer-module-scss-module__h6ijda__menuWrapper",
  "planTag": "userProfileBadgeContainer-module-scss-module__h6ijda__planTag",
  "userProfileFallbackContainer": "userProfileBadgeContainer-module-scss-module__h6ijda__userProfileFallbackContainer",
});
